import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFProductWinAdd, EFVideoPlayer } from '@/components/UI/svg/mm100';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Comp({ callBack, type, customClass }: any) {
    const { useLang, useEffect, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();
    const [videoEnterA, setVideoEnterA] = useState(false);
    let controller: any;
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/PgJBYhaNjlo',
        cn: {
            SD: 'https://videos.ecoflow.com/f403779199b149048644c5a86cb5a798/607be7e1cc2746009784dcfc3a21fe74-9075ea9f6dda36d15deee22d3c9b33a6-fd.mp4',
            HD: 'https://videos.ecoflow.com/f403779199b149048644c5a86cb5a798/607be7e1cc2746009784dcfc3a21fe74-1ac38e814bb3020a0b7dedbabb15f7d0-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/2d943068-1842c317666-0004-9c91-e6d-40030.mp4',
        },
    };

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.listBH5 .video-box`,
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 1.2, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });

        controller.addScene(sceneA1);
    }, []);

    const videoMap: any = {
        us: [`/video/mm100/listBH5_${type}.webm`, `/video/mm100/listBH5_${type}.mp4`],
        cn: [`/video/mm100/listBH5_${type}_cn.webm`, `/video/mm100/listBH5_${type}_cn.mp4`],
        de: [`/video/mm100/listBH5_${type}_de.webm`, `/video/mm100/listBH5_${type}_de.mp4`],
        fr: [`/video/mm100/listBH5_${type}_fr.webm`, `/video/mm100/listBH5_${type}_fr.mp4`],
        it: [`/video/mm100/listBH5_${type}_it.webm`, `/video/mm100/listBH5_${type}_it.mp4`],
        es: [`/video/mm100/listBH5_${type}_es.webm`, `/video/mm100/listBH5_${type}_es.mp4`],
    };

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow Power Kits - Compact and Integrated Power Solution',
            position,
        });
        setShowEFVideoModal(true);
    };

    return (
        <div className={`${css.listBH5} listBH5 ${customClass}`}>
            <h2 className="title">{t('presale.product.listB_title')}</h2>
            <p className="desc">{t('presale.product.listB_desc')}</p>
            <div className="more-win-line">
                <div className="more-win-fun more-win-fun2" onClick={() => callBack('appModalH5')}>
                    {t('presale.product.h5_learn_more')}
                    <span className="more-win-fun-icon">
                        <EFProductWinAdd />
                    </span>
                </div>
            </div>
            <div className="video-box">
                {videoEnterA && <EFVideo sources={videoMap[locale] || videoMap.us} className="video listB-video" />}
                <div className="text">
                    <li className="kit-msg">{t('presale.product.listB_msg1')}</li>
                    <li className="kit-msg">{t('presale.product.listB_msg2')}</li>
                    <li className="kit-msg">{t('presale.product.listB_msg3')}</li>
                </div>
                <div className="watch-video-btn" onClick={() => playerVideo(t('presale.product.listB_title'))}>
                    <span className="watch-text">{t('presale.product.watch_video')}</span>
                    <EFVideoPlayer className="icon" color="#FFF" />
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
